<script setup lang="ts">
import UsersTable from "@/components/users-table.vue";
import { useLoggedInUserFlags } from "@/composables/use-logged-in-user-flags";
import { Role } from "@/models/enums/role";
import { RouteName } from "@/router";
import { ref } from "vue";

const CUSTOMER_SERVICE_CUSTOMER_NUMBER = "100000";

const { userIsOneAdmin, userIsCustomerAdmin, userIsOneUserAdmin } =
  useLoggedInUserFlags(CUSTOMER_SERVICE_CUSTOMER_NUMBER);

const pageLoading = ref(false);
</script>

<template>
  <section class="section px-0">
    <p class="title is-4">Kundtjänst</p>

    <app-loader v-if="pageLoading"></app-loader>
  </section>
  <template v-if="!pageLoading">
    <section
      class="section notification has-background-folly-light has-text-folly-dark"
    >
      <div class="columns is-justify-content-space-between">
        <div class="column">
          <p class="title is-5">Kundtjänstadministratörer</p>
        </div>

        <div class="column is-narrow is-flex is-align-items-flex-end">
          <router-link
            v-if="userIsOneAdmin"
            :to="{
              name: RouteName.CustomerServiceCreateAdmin,
              params: { customerNumber: CUSTOMER_SERVICE_CUSTOMER_NUMBER },
            }"
            class="button"
            >Skapa kundtjänstadministratör</router-link
          >
        </div>
      </div>

      <users-table
        :customer-number="CUSTOMER_SERVICE_CUSTOMER_NUMBER"
        :role="Role.ONE_USER_ADMIN"
        :deleteable="userIsOneAdmin"
        status-info-column
        status-action-column
        show-all-customer-users
      ></users-table>
    </section>

    <section
      class="section notification has-background-emerald-light has-text-emerald-dark"
    >
      <div class="columns is-justify-content-space-between">
        <div class="column">
          <p class="title is-5 mb-2">Kundtjänstanvändare</p>
        </div>

        <div class="column is-narrow is-flex is-align-items-flex-end">
          <router-link
            v-if="userIsOneAdmin || userIsCustomerAdmin || userIsOneUserAdmin"
            :to="{
              name: RouteName.CustomerServiceCreateUser,
              params: { customerNumber: CUSTOMER_SERVICE_CUSTOMER_NUMBER },
            }"
            class="button"
            >Skapa kundtjänstanvändare</router-link
          >
        </div>
      </div>

      <users-table
        :customer-number="CUSTOMER_SERVICE_CUSTOMER_NUMBER"
        :role="Role.ONE_USER"
        :deleteable="
          userIsOneAdmin || userIsCustomerAdmin || userIsOneUserAdmin
        "
        status-info-column
        status-action-column
        show-all-customer-users
      ></users-table>
    </section>
  </template>
</template>
